module.exports = __webpack_public_path__ + "static/4-972fb7a7a0646631a222bd241495f290.jpg";